import React from "react";
import "../../assets/css/searching.css";

const Searchlist = ({ value, onChange, placeholder = "Search..." }) => {
  return (
    <div className="row">
      <div className="col-9">
    <div
      className="relative w-full max-w-sm mb-1 max-w-sm001"
      style={{ marginLeft: "12px" }}
    >
      <input
        type="search"
        placeholder={placeholder}
        value={value}
        onChange={onChange}
        className="w-full h-35 pl-10 pr-4 rounded  input-box"
        style={{ outline: "none" }}
      />

      <div
        className="absolute inset-y-0 left-0 pl-3 d-flex align-items-center iconbox001"
        style={{ color: "rgb(146,146,146)" }}
      >
        <i className="bi bi-search"></i>
      </div>
    </div>
    </div>
    </div>
  );
};

export default Searchlist;